import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "ant-row" }
const _hoisted_2 = { class: "ant-col ant-col-xs-6 ant-col-xl-4" }
const _hoisted_3 = { class: "ant-col ant-col-xs-6 ant-col-xl-5" }
const _hoisted_4 = { class: "ant-col ant-col-xs-6 ant-col-xl-5" }
const _hoisted_5 = { class: "ant-col ant-col-xs-6 ant-col-xl-6" }
const _hoisted_6 = { class: "ant-col ant-col-xs-6 ant-col-xl-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_selecionar_data = _resolveComponent("selecionar-data")!
  const _component_campo_numerico = _resolveComponent("campo-numerico")!
  const _component_card = _resolveComponent("card")!

  return (_openBlock(), _createBlock(_component_card, { titulo: "Detalhes do Lote" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_a_form_item, {
            label: "Número do Lote",
            class: "ss-margin-campos"
          }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "ant-input",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.computedRastreabilidadeLote.numeroLote) = $event))
              }, null, 512), [
                [_vModelText, _ctx.computedRastreabilidadeLote.numeroLote]
              ])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_a_form_item, {
            label: "Fabricação/Produção",
            class: "ss-margin-campos"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_selecionar_data, {
                "data-selecionada": _ctx.computedRastreabilidadeLote.dataFabricacao,
                "onUpdate:dataSelecionada": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.computedRastreabilidadeLote.dataFabricacao) = $event))
              }, null, 8, ["data-selecionada"])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_a_form_item, {
            label: "Validade",
            class: "ss-margin-campos"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_selecionar_data, {
                "data-selecionada": _ctx.computedRastreabilidadeLote.dataValidade,
                "onUpdate:dataSelecionada": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.computedRastreabilidadeLote.dataValidade) = $event))
              }, null, 8, ["data-selecionada"])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_a_form_item, {
            label: "Preço Máximo ao Consumidor",
            class: "ss-margin-campos"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_campo_numerico, {
                monetario: true,
                valor: _ctx.computedRastreabilidadeLote.precoMaximoConsumidor,
                "onUpdate:valor": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.computedRastreabilidadeLote.precoMaximoConsumidor) = $event))
              }, null, 8, ["valor"])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_a_form_item, {
            label: "Quantidade",
            class: "ss-margin-campos"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_campo_numerico, {
                valor: _ctx.computedQtdRastreabilidade,
                "onUpdate:valor": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.computedQtdRastreabilidade) = $event)),
                quantidadeCasasDecimais: _ctx.props.qtdCasasDecimais
              }, null, 8, ["valor", "quantidadeCasasDecimais"])
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }))
}